<!--
  Copyright (c) 2020 BuserNet Consulting LLC
  All rights reserved.
 -->
<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="dark">
        <ion-buttons slot="start">
          <ion-button
            fill="solid"
            color="secondary"
            @click="closeModal(false)"
          >
            Close
          </ion-button>
        </ion-buttons>
        <ion-title>Change Password</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-card class="transparent-card">
        <ion-card-content>
          <div>
            <form
              id="loginregisterformprimary"
              name="loginregisterformprimary"
              novalidate
            >
              <p
                v-show="changePasswordValidation"
                class="validationmessage"
              >
                {{ changePasswordValidation }}
              </p>
              <ion-item>
                <ion-label position="floating">
                  New Password
                </ion-label>
                <ion-input
                  v-model="changePasswordForm.newPassword"
                  color="light"
                  type="password"
                />
              </ion-item>
              <ion-item>
                <ion-label position="floating">
                  Confirm Password
                </ion-label>
                <ion-input
                  v-model="changePasswordForm.confirmPassword"
                  color="light"
                  type="password"
                />
              </ion-item>
              <div class="clear-login-div" />
              <ion-button
                shape="round"
                :disabled="!isChangePasswordFormComplete"
                color="light"
                fill="solid"
                class="button-account-secondary"
                expand="full"
                @click="onChangeOldPassword()"
              >
                Change Password
              </ion-button>
            </form>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </div>
</template>
<script>
import {
  IonContent,
  IonHeader,
  IonItem,
  IonInput,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardContent,
  IonButtons,
  IonButton,
  IonLabel,
  modalController,
} from '@ionic/vue';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { hideIonicLoading, showIonicLoading } from '../services/loading.service';
import utilityService from '../services/utility.service';
import AccountConst from '../constants/account.constant';
import { changeOldPassword } from '../services/aws/user/changeOldPassword';
import { STORE_NAMESPACE } from '../store/modules/store.namespace';
import { USER_GETTERS_ENUM } from '../store/modules/user/user.enum';

export default defineComponent({
  name: 'Changepassword',
  components: {
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonCard,
    IonCardContent,
    IonButton,
    IonButtons,
    IonLabel,
    IonItem,
    IonInput,
  },
  data() {
    return {
      changePasswordForm: {
        newPassword: '',
        confirmPassword: '',
      },
      changePasswordValidation: '',
    };
  },
  computed: {
    ...mapGetters(STORE_NAMESPACE.USER, {
      user: USER_GETTERS_ENUM.GET_USER_DETAILS,
    }),
    isChangePasswordFormComplete() {
      return this.checkChangePasswordFormValid();
    },
  },
  methods: {
    closeModal() {
      modalController.dismiss();
    },
    passwordChangedSuccess() {
      showIonicLoading(AccountConst.processingText.passwordChanged, true);
      utilityService.deleteForgotPasswordState();
      this.changePasswordValidation = '';
      setTimeout(() => {
        hideIonicLoading();
        this.closeModal();
      }, AccountConst.durationOfPwdChangeSuccess);
    },
    onChangeOldPassword() {
      if (this.changePasswordForm.newPassword) {
        if (this.changePasswordForm.newPassword === this.changePasswordForm.confirmPassword) {
          if (this.changePasswordForm.newPassword.length < 6) {
            this.changePasswordValidation = AccountConst.passwordMinLengthRequired;
            return;
          }
          this.changePasswordValidation = '';
          showIonicLoading(AccountConst.processingText.pleaseWait, false);
          changeOldPassword(this.changePasswordForm, this.user).then((data) => {
            hideIonicLoading();
            if (!data.message) {
              this.passwordChangedSuccess(false);
            } else {
              this.changePasswordValidation = data.message;
            }
          });
        } else {
          this.changePasswordValidation = AccountConst.passwordNotMatch;
        }
      }
    },
    checkChangePasswordFormValid() {
      if (this.changePasswordForm.confirmPassword.length > 0
        && this.changePasswordForm.newPassword.length > 0) {
        return true;
      }
      return false;
    },
  },
});
</script>
<style scoped>
ion-content{
  --background: #1C1C1C;
  border-left: 5px solid #20232C;
  border-right: 5px solid #20232C;
  border-bottom: 5px solid #20232C;
}
ion-card {
  background: transparent;
}
ion-card-content{
  padding: 0;
}
ion-item{
color: #fff;
--background: transparent;
}
.message{
  margin: 12px 0;
}

</style>
